// src/utils/index.js
import apiConfig from '@/config/api'

/**
 * 拼接完整的图片地址
 * @param {string} path 图片相对路径，如 '/uploads/avatar.png'
 * @returns {string} 完整的图片 URL
 */
export function imageUrl (path) {
  if (path == null || path === '') {
    // 使用 SVG 数据 URI 作为默认头像 - 符合主题色的用户图标
    // 主题色：橙色渐变背景 + 白色用户图标
    return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiByeD0iNTAiIGZpbGw9InVybCgjZ3JhZGllbnQwX2xpbmVhcl8xXzEpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9ImdyYWRpZW50MF9saW5lYXJfMV8xIiB4MT0iMCIgeTE9IjAiIHgyPSIxMDAiIHkyPSIxMDAiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI0ZGOUMwMCIvPgo8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNGRjZEMDAiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8cGF0aCBkPSJNNTAgMzVDNDQuNDc3MSAzNSA0MCAzOS40Nzc3IDQwIDQ1QzQwIDUwLjUyMjMgNDQuNDc3MSA1NSA1MCA1NUM1NS41MjI5IDU1IDYwIDUwLjUyMjMgNjAgNDVDNjAgMzkuNDc3NyA1NS41MjI5IDM1IDUwIDM1WiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC45Ii8+CjxwYXRoIGQ9Ik01MCA2MEM0MC4wNTg5IDYwIDMyIDY4LjA1ODkgMzIgNzhWODVDMzIgODcuNzYxNCAzNC4yMzg2IDkwIDM3IDkwSDYzQzY1Ljc2MTQgOTAgNjggODcuNzYxNCA2OCA4NVY3OEM2OCA2OC4wNTg5IDU5Ljk0MTEgNjAgNTAgNjBaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjkiLz4KPC9zdmc+'
  }
  const baseUrl = apiConfig.baseUrl // 获取当前环境的 base URL
  return `${baseUrl}${path}`
}
